import { render } from "./project-place-detail.vue?vue&type=template&id=79401af1&scoped=true&ts=true"
import script from "./project-place-detail.vue?vue&type=script&lang=ts"
export * from "./project-place-detail.vue?vue&type=script&lang=ts"

import "./project-place-detail.vue?vue&type=style&index=0&id=79401af1&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79401af1"]])

export default __exports__